import React from 'react';

export const HackerNewsLogo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <rect width="512" height="512" rx="15%" fill="#f60" />
      <path
        fill="#ffffff"
        d="M124 91h51l81 162 81-164h51L276 293v136h-40V293z"
      />
    </svg>
  </div>
);
